export const CLASS_CARD_DETAILS_TAB_TIMING = 'card-details-timing';
